import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    leading-[120%]
  `,
  {
    variants: {
      color: {
        default: 'text-neutral-600',
        disabled: 'text-neutral-400',
        emphasis: 'text-neutral-700',
        header: 'text-neutral-900',
        link: 'text-neutral-900',
        muted: 'text-neutral-500',
        danger: 'text-danger',
        brand: 'text-brand',
        priority: 'text-priority',
        yellow: 'text-yellow-200',
        moss: 'text-moss-200',
        red: 'text-red-200',
        orange: 'text-orange-200',
        green: 'text-green-200',
        inherit: 'text-inherit',
        white: 'text-neutral-0',
      },
      textAlign: {
        center: 'text-center',
        left: 'text-left',
        right: 'text-right',
        inherit: 'text-inherit',
      },
      variant: {
        displayLg: 'display-lg',
        displayMd: 'display-md',
        displaySm: 'display-sm',
        displayXs: 'display-xs',
        displayXxs: 'display-xxs',
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        eyebrow: 'eyebrow',
        labelLg: 'label-lg',
        labelMd: 'label-md',
        labelSm: 'label-sm',
        labelXs: 'label-xs',
        bodyLg: 'body-lg',
        bodyMd: 'body-md',
        bodySm: 'body-sm',
        bodyXs: 'body-xs',
      },
    },
    defaultVariants: {
      color: 'default',
      textAlign: 'left',
      variant: 'bodySm',
    },
  }
)
